import React, { useEffect } from 'react';

const pillars = [
  { icon: 'ti-users',        label: 'Expert Mentorship'    },
  { icon: 'ti-shield-check', label: 'Trusted & Compliant'  },
  { icon: 'ti-network',      label: 'Strong Network'       },
  { icon: 'ti-trending-up',  label: 'Sustainable Growth'   },
  { icon: 'ti-world',        label: 'Global Opportunities' },
];

const Categories = () => {
  useEffect(() => {
    const s = document.createElement('style');
    s.textContent = `
      @keyframes sdFlow { to { stroke-dashoffset: -32; } }
      @keyframes cFadeUp { from{opacity:0;transform:translateY(12px);}to{opacity:1;transform:translateY(0);} }
      @keyframes cFloat { 0%,100%{transform:translateY(-50%);}50%{transform:translateY(calc(-50% - 5px));} }
      .cat-card:hover { transform:scale(1.02)!important; box-shadow:0 6px 20px rgba(0,0,0,.08)!important; }
      .cat-card-mid:hover { transform:translateY(-50%) scale(1.02)!important; box-shadow:0 6px 20px rgba(0,0,0,.08)!important; }
    `;
    document.head.appendChild(s);
    return () => document.head.removeChild(s);
  }, []);

  const base = { position:'absolute', borderRadius:16, padding:'16px 15px', transition:'all .2s' };
  const wCard = { ...base, background:'#fff', border:'1.5px solid #1a1a1a' };
  const gCard = { ...base, background:'#f0f8f0', border:'1.5px solid #3B6D11' };
  const numF  = { width:26, height:26, borderRadius:'50%', background:'#1a1a1a', color:'#fff', fontSize:12, fontWeight:500, display:'flex', alignItems:'center', justifyContent:'center', marginBottom:10 };
  const numO  = { ...numF, background:'transparent', border:'1.5px solid #1a1a1a', color:'#1a1a1a' };
  const ttl   = (c='#1a1a1a') => ({ fontSize:11, fontWeight:500, textTransform:'uppercase', letterSpacing:'.06em', color:c, lineHeight:1.35, marginBottom:5 });
  const dsc   = { fontSize:10.5, color:'#666', lineHeight:1.55 };
  const em    = { fontSize:26, marginBottom:8 };

  return (
    <section id="categories" style={{ background:'#f0ede7', padding:'20px 16px 14px', fontFamily:'var(--font-sans)' }}>
      <div style={{ maxWidth:760, margin:'0 auto' }}>

        {/* Logo area — left empty for user to insert logos */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:20, marginBottom:14, minHeight:52, flexWrap:'wrap' }}>
          <div style={{ width:180, height:44, borderRadius:8, border:'0.5px dashed #bbb', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ fontSize:11, color:'#aaa', letterSpacing:'.06em' }}>YOUR LOGO HERE</span>
          </div>
          <div style={{ width:1, height:40, background:'#bbb' }} />
          <div style={{ width:100, height:36, borderRadius:20, border:'0.5px dashed #bbb', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ fontSize:10, color:'#aaa' }}>GTDC</span>
          </div>
          <div style={{ width:1, height:40, background:'#bbb' }} />
          <div style={{ width:160, height:44, borderRadius:8, border:'0.5px dashed #bbb', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ fontSize:11, color:'#aaa', letterSpacing:'.06em' }}>PARTNER LOGO</span>
          </div>
        </div>

        {/* Tagline */}
        <p style={{ textAlign:'center', fontSize:19, fontWeight:500, color:'#1a1a1a', margin:'0 0 4px', animation:'cFadeUp .5s ease both' }}>
          Your Journey. <span style={{ color:'#0F6E56' }}>Our Support.</span> Market Success.
        </p>

        {/* Flow map */}
        <div style={{ position:'relative', height:460 }}>

          <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', pointerEvents:'none', overflow:'visible' }} viewBox="0 0 680 460" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <marker id="ag" viewBox="0 0 12 12" refX="9" refY="6" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
                <path d="M2 2L10 6L2 10" fill="none" stroke="#2d6a4f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </marker>
              <marker id="ao" viewBox="0 0 12 12" refX="9" refY="6" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
                <path d="M2 2L10 6L2 10" fill="none" stroke="#BA7517" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </marker>
            </defs>
            <path d="M468 108 Q530 60 530 160"  fill="none" stroke="#2d6a4f" strokeWidth="2" strokeDasharray="9 5" strokeLinecap="round" markerEnd="url(#ag)" style={{animation:'sdFlow 2s linear infinite'}}/>
            <path d="M530 260 Q530 330 530 348" fill="none" stroke="#2d6a4f" strokeWidth="2" strokeDasharray="9 5" strokeLinecap="round" markerEnd="url(#ag)" style={{animation:'sdFlow 2s linear infinite .4s'}}/>
            <path d="M488 428 Q430 460 350 420" fill="none" stroke="#2d6a4f" strokeWidth="2" strokeDasharray="9 5" strokeLinecap="round" markerEnd="url(#ag)" style={{animation:'sdFlow 2s linear infinite .8s'}}/>
            <path d="M276 400 Q220 380 180 340" fill="none" stroke="#2d6a4f" strokeWidth="2" strokeDasharray="9 5" strokeLinecap="round" markerEnd="url(#ag)" style={{animation:'sdFlow 2s linear infinite 1.2s'}}/>
            <path d="M196 220 Q230 120 286 108" fill="none" stroke="#2d6a4f" strokeWidth="2" strokeDasharray="9 5" strokeLinecap="round" markerEnd="url(#ag)" style={{animation:'sdFlow 2s linear infinite 1.6s'}}/>
            <path d="M650 210 Q665 230 662 238"  fill="none" stroke="#BA7517" strokeWidth="2" strokeDasharray="7 4" strokeLinecap="round" markerEnd="url(#ao)" style={{animation:'sdFlow 2.5s linear infinite .6s'}}/>
          </svg>

          {/* Step 1 — top, slightly left of center */}
          <div className="cat-card" style={{...wCard, left:210, top:18, width:175, animation:'cFadeUp .5s .1s ease both'}}>
            <div style={numF}>1</div>
            <div style={em}>💡</div>
            <div style={ttl()}>Idea Development with Experts</div>
            <div style={dsc}>Get expert mentorship, validate your idea and shape your business model.</div>
          </div>

          {/* Step 2 — top right */}
          <div className="cat-card" style={{...gCard, left:412, top:130, width:165, animation:'cFadeUp .5s .2s ease both'}}>
            <div style={numO}>2</div>
            <div style={em}>📋</div>
            <div style={ttl('#085041')}>Business Registration & Compliance</div>
            <div style={dsc}>Hassle-free registration and compliance support to keep you 100% compliant.</div>
          </div>

          {/* Step 3 — bottom right */}
          <div className="cat-card" style={{...gCard, left:412, top:340, width:165, animation:'cFadeUp .5s .4s ease both'}}>
            <div style={numO}>3</div>
            <div style={em}>💰</div>
            <div style={ttl('#085041')}>Access to Potential Financing</div>
            <div style={dsc}>Connect with investors, lenders and funding partners to fuel your growth.</div>
          </div>

          {/* Step 4 — bottom left of center */}
          <div className="cat-card" style={{...wCard, left:210, top:340, width:175, animation:'cFadeUp .5s .3s ease both'}}>
            <div style={numF}>4</div>
            <div style={em}>📈</div>
            <div style={ttl()}>Business Growth & Readiness</div>
            <div style={dsc}>Strengthen your business, build capacity and get ready to scale.</div>
          </div>

          {/* Step 5 — far left standalone */}
          <div className="cat-card-mid" style={{...wCard, left:14, top:'50%', transform:'translateY(-50%)', width:148, animation:'cFadeUp .5s .15s ease both'}}>
            <div style={numF}>5</div>
            <div style={em}>🌍</div>
            <div style={ttl()}>Scale & Impact</div>
            <div style={dsc}>Expand reach, create jobs and deliver sustainable impact.</div>
          </div>

          {/* Market Access — far right */}
          <div style={{ position:'absolute', right:4, top:'50%', width:115, textAlign:'center', animation:'cFloat 3s ease-in-out infinite' }}>
            <div style={{ width:82, height:82, borderRadius:'50%', background:'#f0f8f0', border:'2px solid #3B6D11', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 8px' }}>
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                <circle cx="15" cy="15" r="12" stroke="#0F6E56" strokeWidth="1.5"/>
                <path d="M15 4c-3 5-3 17 0 22M15 4c3 5 3 17 0 22M4 12h22M4 18h22" stroke="#0F6E56" strokeWidth="1.2" strokeLinecap="round"/>
              </svg>
            </div>
            <div style={{ fontSize:11, fontWeight:500, textTransform:'uppercase', letterSpacing:'.06em', color:'#085041', lineHeight:1.2 }}>Market Access</div>
            <div style={{ fontSize:10, color:'#3B6D11', marginTop:3, lineHeight:1.4 }}>Showcase on the Experts Marketplace</div>
          </div>

        </div>

        {/* Pillars pill bar */}
        <div style={{ display:'flex', background:'#fff', border:'1px solid #ccc', borderRadius:50, overflow:'hidden', marginTop:10 }}>
          {pillars.map((p, i) => (
            <div key={p.label} style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:4, padding:'10px 4px', borderRight: i < pillars.length-1 ? '0.5px solid #eee' : 'none' }}>
              <i className={`ti ${p.icon}`} style={{ fontSize:17, color:'#0F6E56' }} aria-hidden="true"/>
              <span style={{ fontSize:9, color:'#555', textTransform:'uppercase', letterSpacing:'.07em', fontWeight:500, textAlign:'center', lineHeight:1.3 }}>{p.label}</span>
            </div>
          ))}
        </div>

        <p style={{ textAlign:'center', fontSize:11, color:'#999', letterSpacing:'.1em', marginTop:8 }}>
          —— One Ecosystem. End-to-End Support. Infinite Possibilities. ——
        </p>

      </div>
    </section>
  );
};

export default Categories;